import React from "react";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import { BriefcaseBusiness, MapPin, Building2, Clock, GraduationCap, Users, Wallet, Copy, X, FileText, ListChecks, ExternalLink, Download } from "lucide-react";
import "./JobInformationModal.css";

export default function JobInformationModal({ isOpen, onClose, job, onCopy }) {
  const reportingManager = job?.reporting_manager;
  const reportingManagerName =
    job?.reporting_manager_name ||
    (reportingManager && typeof reportingManager === "object"
      ? reportingManager.name || reportingManager.full_name || reportingManager.display_name
      : "") ||
    "Not assigned";
  const facts = job ? [
    { label: "Experience", icon: BriefcaseBusiness, value: job.min_exp || job.max_exp ? `${job.min_exp || 0} - ${job.max_exp || 0} years` : "N/A" },
    { label: "Package / Budget", icon: Wallet, value: job.salary_max || "N/A" },
    { label: "Openings", icon: Users, value: job.openings ?? "N/A" },
    { label: "Qualification", icon: GraduationCap, value: job.education_level || "N/A" },
    { label: "Reporting Manager", icon: Users, value: reportingManagerName },
  ] : [];
  return (
    <Modal isOpen={isOpen} toggle={onClose} centered className="job-information-dialog" aria-labelledby="job-information-heading">
      <header className="job-information-header">
        <div className="job-information-heading"><BriefcaseBusiness size={20} aria-hidden="true" /><h2 id="job-information-heading">Job Information</h2></div>
        <button type="button" className="job-information-close" onClick={onClose} aria-label="Close Job Information" title="Close"><X size={20} /></button>
      </header>
      <ModalBody className="job-information-body">
        {job ? <>
          <section className="job-information-overview">
            <h3>{job.job_title || "Untitled Job"}</h3>
            <div className="job-information-meta">
              <span><MapPin size={16} aria-hidden="true" />{job.location || "Location N/A"}</span>
              <span><Building2 size={16} aria-hidden="true" />{job.workplace_name || "Mode N/A"}</span>
              <span><Clock size={16} aria-hidden="true" />{job.shift || "Shift N/A"}</span>
            </div>
          </section>
          <dl className="job-information-facts">
            {facts.map(({ label, icon: Icon, value }) => <div key={label}>
              <dt><Icon size={18} aria-hidden="true" />{label}</dt><dd>{value}</dd>
            </div>)}
          </dl>
          <section className="job-information-section">
            <h4><ListChecks size={18} aria-hidden="true" />Required Key Skills</h4>
            <div className="job-information-skills">{job.skills?.length ? job.skills.map((skill, index) => <span key={`${skill}-${index}`}>{skill}</span>) : <span>N/A</span>}</div>
          </section>
          {[
            { title: "Job Description", icon: FileText, content: job.job_description },
            { title: "Roles & Responsibilities", icon: ListChecks, content: job.roles_responsibility },
          ].map(({ title, icon: Icon, content }) => <section key={title} className="job-information-section">
            <h4><Icon size={18} aria-hidden="true" />{title}</h4>
            <div className="job-information-rich-text" dangerouslySetInnerHTML={{ __html: content || "N/A" }} />
          </section>)}
          <section className="job-information-section">
            <h4><GraduationCap size={18} aria-hidden="true" />Preferred Qualifications</h4>
            <p>Experience working in a US Shift or a 24/7 support environment</p>
          </section>
          {(job.website_url || job.jd_document) && <div className="job-information-links">
            {job.website_url && <a href={job.website_url} target="_blank" rel="noopener noreferrer"><ExternalLink size={16} aria-hidden="true" />Open Apply Link</a>}
            {job.jd_document && <a className="job-information-download" href={job.jd_document} target="_blank" rel="noopener noreferrer"><Download size={16} aria-hidden="true" />Download JD Document</a>}
          </div>}
        </> : <p>Job information is unavailable.</p>}
      </ModalBody>
      <ModalFooter className="job-information-footer">
        <Button color="primary" onClick={onCopy} disabled={!job}><Copy size={16} aria-hidden="true" />Copy Content</Button>
        <Button color="secondary" outline onClick={onClose}><X size={16} aria-hidden="true" />Close</Button>
      </ModalFooter>
    </Modal>
  );
}
